import { render } from "./drumKit.vue?vue&type=template&id=0368f69f&scoped=true"
import script from "./drumKit.vue?vue&type=script&lang=js"
export * from "./drumKit.vue?vue&type=script&lang=js"

import "./drumKit.vue?vue&type=style&index=0&id=0368f69f&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0368f69f"]])

export default __exports__